/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'

const baseUrl = `invoice_partner`
export default {
  /**
   * reqBillList
   * @description 获取开票管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceManageList(data) {
    return request.post(`/${baseUrl}/list`, data)
  },
  /**
   * reqBillList
   * @description 开票管理详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceManageDetail(data) {
    return request.post(`/${baseUrl}/view`, data)
  },
  getdownZIP(data) {
    return request.post(`/${baseUrl}/download`, data)
  },
  /**
   * getInvoiceManageEdit
   * @description 发票寄出
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceManageEdit(data) {
    return request.post(`/${baseUrl}/edit`, data)
  },
  /**
   *
   * @description 上传开票信息
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  uploadInvoiceInfo(data) {
    return request.post(`/${baseUrl}/upload_img`, data)
  },
  
  lingxinUploadInvoiceInfo(data) {
    return request.post(`/${baseUrl}/apply_lingxin`, data)
  },
   /**
   *
   * @description 开票管理开票详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceManageDetail(data) {
    return request.post(`/${baseUrl}/detail`, data)
  },
  /**
   *
   * @description 开票管理快递详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceManageExpressDetails(data) {
    return request.post(`/${baseUrl}/express`, data)
  },
  // 劳务派遣订单列表
  invoiceManageOrderList(data){
    return request.post('/invoice/order/list',data)
  }
}